// @flow
import { resolve } from 'redux-optimist-promise';

import {
  CLEAR_ADDITIONAL_ACCOMMODATIONS,
  FETCH_ADDITIONAL_ACCOMMODATIONS,
} from 'Store/booking/additional-accommodations/additionalAccommodations.action';

type State = ?Array<Accommodation>;

const initialState: State = [];

function accommodationsSetsReducer(state: State = initialState, action: Action<*>): State {
  switch (action.type) {
    case CLEAR_ADDITIONAL_ACCOMMODATIONS:
    case FETCH_ADDITIONAL_ACCOMMODATIONS:
      return initialState;

    case resolve(FETCH_ADDITIONAL_ACCOMMODATIONS):
      return (
        (action?.payload?.additionalAccommodations || [])
          /**
           * Sometimes we get a corner case from API responses where arrangement accommodation does not match any of resort accommodations
           * In this case we could get and accommodationsSet with empty accommodations field... It makes no sense to display it to the user
           * See https://github.com/ClubMediterranee/cm-b2c/issues/14959
           */
          .filter(
            additionalAccommodationSet =>
              additionalAccommodationSet.accommodations &&
              additionalAccommodationSet.accommodations.length > 0,
          )
          .map((accommodation, index) => ({
            ...accommodation,
            accommodationSetNumber: index + 1,
          }))
      );

    default:
      return state;
  }
}

export default accommodationsSetsReducer;
